import { makeStyles } from "@material-ui/core";
import React, {useRef} from "react";
import "./ToggleBtn.css";

const useStyles = makeStyles();

function ToggleBtn({
  styleType,
  label,
  view,
  handleToggle,
  handleToggleRef,
  toggleState,
  field,
  backgroundStyle,
  externalStyling,
  handleCaching,
  index,
}) {
  const classes = useStyles();

  const tglRef = useRef(null);
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";      

  return (
    <div
      className={
        "toggleBtn" + " " + (externalStyling ? externalStyling.toggle : "")+" control-class"
      }
    >
      <span>{label}</span>
      <div className="slideBar" style={externalStyling?.quickToolSlideBarStyle || {}}>
        <label
          aria-label="Toggle Button"
          className={ 
            translationStyles1 ?
            "switchArabic" + " " + (externalStyling?.center || "") + (externalStyling?.quickToolSwitchStyle ||  ""):
            "switch" + " " + (externalStyling?.center || "") + (externalStyling?.quickToolSwitchStyle ||  "")
          }
        >
          {((toggleState+"") === "true" || toggleState === true) 
          ? (
            <input
              aria-label={"Show Progress"}
              ref={tglRef}
              type="checkbox"
              checked
              tabIndex={-1}
              name="showProgress"
              onClick={(e) => {
                handleToggle && handleToggle(e, field);
                handleCaching && handleCaching(index);
              }}
              value={ "true"}
            />
          ) 
          : 
          (
            <input
              aria-label={"Show Progress2"}
              ref={tglRef}
              type="checkbox"
              name="showProgress"
              value={"false"}
              tabIndex={-1}
              checked={false}
              onClick={(e) => {
                handleToggle && handleToggle(e, field);
                handleCaching && handleCaching(index);
              }}
            />
          )}
          <span
            className={
              styleType === "2"
                ? "slider2 slider round"
                : "slider round" +
                  " " +
                  (externalStyling ? externalStyling.input : "")
            }
            onClick={(e) => {
              handleToggleRef && handleToggleRef(tglRef, field, 'toggle');
            }}
            style={backgroundStyle}
            tabIndex={0}
          ></span>
          {styleType === "3" && <span className="sliderText"></span>}
        </label>
      </div>
    </div>
  );
}

export default ToggleBtn;